import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import React from 'react';
import Select from 'react-select';

const styles = () => ({
  dialogContent: {
    height: 500,
  },
  dialogBorder: {
    height: '20px',
  },
  title: {
    marginBottom: '.5em',
  },
});

class CrossReferencesModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: '',
      selectedTerm: '',
      termOptions: [],
    };
  }

  render() {
    const { references, classes } = this.props;
    return (
      <div>
        <Dialog
          open={this.props.open}
          onClose={this.props.handleClose}
          fullWidth
        >
          <div className={classes.dialogBorder} />
          <DialogTitle>
            <Typography variant="h4" className={classes.textCaps}>
              Cross References
            </Typography>
            <Typography style={{ marginTop: 7 }}>
              <i>
                A cross reference is a way to add the same term under multiple
                different parent terms. You can specify additional parent terms
                here.
              </i>
            </Typography>
            <Typography style={{ marginTop: 7 }}>
              <i>
                <b>Ex: </b>the parent of 'Bioengineering' is 'Engineering'.
                However, if we wanted 'Bioengineering' to also appear under
                'Medicine', we would add 'Medicine' as a cross-reference for
                'Bioengineering'
              </i>
            </Typography>
          </DialogTitle>
          <div className={classes.dialogBody}>
            <DialogContent className={classes.dialogContent}>
              {/* CURRENT CROSS REFERENCES */}
              <Typography variant="h5">Current Cross References</Typography>
              {references && references.length > 0 ? (
                references.map((term) => (
                  <div>
                    <Typography style={{ display: 'inline-block' }}>
                      {term}
                    </Typography>
                    <Button
                      style={{ display: 'inline-block' }}
                      onClick={() => this.props.deleteCrossReference(term)}
                    >
                      <u style={{ color: 'purple' }}>(DELETE)</u>
                    </Button>
                  </div>
                ))
              ) : (
                <Typography>
                  <i>This term currently does not have any cross references</i>
                </Typography>
              )}
              {/* ADD NEW CROSS REFERENCE */}
              <div style={{ marginTop: '1em' }}>
                <Typography variant="h5">Add Cross Reference</Typography>
                <Typography>
                  <i>Start typing to see options</i>
                </Typography>
                <Select
                  options={this.state.termOptions}
                  styles={colourStyles}
                  onChange={(val) => {
                    this.setState({
                      selectedOption: val,
                      selectedTerm: val.value,
                    });
                  }}
                  onInputChange={(val) => {
                    if (val && val.length && val.length > 0) {
                      this.setState({
                        termOptions: this.props.termOptions.filter(
                          (x) => x.value.substring(0, val.length) === val
                        ),
                      });
                    }
                  }}
                  value={this.state.selectedDefinitionTerm}
                />
              </div>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  if (this.state.selectedTerm !== '') {
                    this.props.addCrossReference(this.state.selectedTerm);
                    this.setState({ selectedTerm: '', selectedOption: {} });
                  }
                }}
                variant="outlined"
              >
                Add Reference
              </Button>
              <Button onClick={this.props.handleClose} variant="outlined">
                Close
              </Button>
            </DialogActions>
          </div>
          <div className={classes.dialogBorder} />
        </Dialog>
      </div>
    );
  }
}

const colourStyles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: '#F7F7F7',
    color: 'black',
    width: 400,
    marginTop: 10,
  }),
  option: (styles, { isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isDisabled
        ? null
        : isSelected
        ? 'grey'
        : isFocused
        ? '#F7F7F7'
        : null,
      ':active': {
        ...styles[':active'],
        backgroundColor: !isDisabled && (isSelected ? 'grey' : 'white'),
      },
    };
  },
};

export default withStyles(styles)(CrossReferencesModal);
